export const environment = {
  production: true,
  hmr: false,
  apiUrl: 'api/',
  reportApiUrl: '/MPSC_FormsReports/api/'
};
